import DefaultElementNodeType from '../DefaultElementNodeType';
import {STRATEGY_CAPABILITY} from '../../metamodel/Concept';

export default class CapabilityNodeType extends DefaultElementNodeType {
	static get typeName() {
		return STRATEGY_CAPABILITY;
	}
}
